module.exports = __webpack_public_path__ + "static/img/ic_noData.e1f6cd17.png";